import { Card, Col, Row } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { SizingTable } from "../../../../Constant";
import { SIZING_TABLE, SIZING_TABLE_BODY, SIZING_TABLE_HEAD } from "../../../../Data/BootstrapTable/BasicTable";
import CommonTable from "../Common/CommonTable";

export const SizingTables=()=> {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={SizingTable} span={SIZING_TABLE} table/>
        <Row className="card-block">
          <Col sm="12" lg="12" xl="12">
            <CommonTable size="lg" headData={SIZING_TABLE_HEAD}>
              {SIZING_TABLE_BODY.map((data) => (
                <tr key={data.id}>
                  <th scope="row">{data.id}</th>
                  <td>{data.employeeName}</td>
                  <td>{data.date}</td>
                  <td className={`font-${data.color}`}>{data.status}</td>
                  <td>{data.hours}</td>
                  <td>{data.performance}</td>
                </tr>
              ))}
            </CommonTable>
          </Col>
        </Row>
      </Card>
    </Col>
  );
}
